<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';
import { ref } from 'vue';
import Loading from '@/components/Loading.vue';

const userStore = useUserStore();
const authStore = useAuthStore();

const { shouldShowInvalidAccessTokenModal } = storeToRefs(authStore);

const isLoading = ref<boolean>(false);

const buttonClickLogin = async () => {
	isLoading.value = true;
	await userStore.logOut();
	isLoading.value = false;
	window.location.reload();
	authStore.hideInvalidAccessTokenModal();
};
</script>

<template>
	<div
		v-bind:aria-hidden="!shouldShowInvalidAccessTokenModal"
		v-if="shouldShowInvalidAccessTokenModal"
		class="fixed inset-x-0 top-0 z-top flex size-full items-center justify-center overflow-hidden bg-gray-900/50 md:inset-0"
	>
		<div class="relative max-h-full max-w-lg p-4">
			<!-- Modal content -->
			<div class="relative flex flex-col items-start justify-start space-y-6 rounded-3xl bg-white p-6 shadow-sm">
				<h3 id="modal-header-add-students" class="text-xl font-bold text-Qblack-900">User session expired</h3>

				<p class="text-justify text-base font-medium text-Qblack-900">You have been logged out. Please log in again.</p>

				<button
					@click="buttonClickLogin"
					type="button"
					:disabled="isLoading"
					class="inline-flex flex-row items-center justify-center self-end rounded-2xl bg-Qblue-900 px-11 py-4 text-center text-sm font-medium text-white hover:bg-Qblue-800"
				>
					<Loading v-if="isLoading" :is-blue="true" class-name="w-4 h-4" />
					Login
				</button>
			</div>
		</div>
	</div>
</template>
